import axios from 'axios'
import endpoints from '../../endpoints'

const API_URL = process.env.REACT_APP_API_URL

export async function fetchSchoolList() {
  try {
    const response = await axios.get(API_URL + endpoints.school.list)
    return response.data
  } catch (error) {
    throw error
  }
}


